<template>

<div class="help-center-articles">

    <div class="sub-header">
        <router-link to="/help-center"><h3>Help Center</h3></router-link>
        <input type="search" v-model="kbItemsSearchTerm" placeholder="Start typing to search...">
        <ul class="filtered-search-kb-items" v-if="filteredSearchKbItems.length > 0">
            <li v-for="(item, index) in filteredSearchKbItems">
                <router-link :to="'/help-center/articles/' + item.kb_item_id">{{ item.category }}<template v-if="item.category != item.topic"> - {{ item.topic }}</template></router-link>
            </li>
        </ul>
    </div>

    <div class="one-three-columns">
        <div class="articles-list">
            <ul>
                <nested-list-item v-for="(item, index) in getKBMenu" :item="item" :adminView="false" :key="'kb-menu-item-' + item.kb_item_id"></nested-list-item>
            </ul>
            <div class="loading full-page" v-if="loading"><i class="fas fa-spinner fa-spin"></i></div>
        </div>
        <router-view />
    </div>

</div>

</template>

<script>
import NestedListItem from '@/modules/dashboard/components/NestedListItem'
import { mapGetters } from "vuex"
export default {
    name: 'help-center-articles',
    props: [ 'kb_item_id' ],
    components: {
        'nested-list-item': NestedListItem
    },
    data() {
        return {
            kbMenu: [],
            kbItemsSearchTerm: null,
            searchKbItems: [],
            kbItems: []
        }
    },
    created() {
        this.fetchData()
    },
    watch: {
        '$route'() {
            this.kbItemsSearchTerm = null
        }
    },
    computed: {
        ...mapGetters('dashboard_module', [
            'getSearchKbItems',
            'getKBMenu',
            'getSupportTickets'
        ]),
        loading() {
            return (this.getSearchKbItems && this.getSearchKbItems.length == 0) || (this.getKBMenu && this.getKBMenu.length == 0)
        },
        filteredSearchKbItems() {
            if (!this.kbItemsSearchTerm) {
                return []
            }
            var filteredSearchKbItems = this.getSearchKbItems.filter(item => {
                return item.search_text.toLowerCase().indexOf(this.kbItemsSearchTerm.toLowerCase()) > -1
            })
            return filteredSearchKbItems
        },
        commonItems() {
            return this.getSearchKbItems.filter(item => item.common == "1")
        },
        commonItemsColumns() {
            console.log(Math.ceil(this.commonItems.length / 4));
            return Math.ceil(this.commonItems.length / 4)
        }
    },
    methods: {
        fetchData() {
            // this.loading = true
            // var data = {}
            // if (this.kb_item_id) {
            //     data.parent_item_id = this.kb_item_id
            // }
            // this.apiCall({ destination: 'get_kb_menu' }).then(obj => {
            //     console.log(obj);
            //     this.loading = false
            //     this.kbMenu = obj.kb_menu
            //     this.constructFlatList(this.kbMenu)
            // }).catch(err => {
            //     this.loading = false
            //     console.log(err);
            // })
        }
    }
}
</script>

<style lang="scss" scoped>
.sub-header {
    display: grid;
    grid-template-columns: 1fr 1fr;
    border-bottom: none;
    ul.filtered-search-kb-items {
        font-size: 1em;
        width: 50%;
        right: 0;
        top: 3.25em;
    }
}
</style>
